module.exports = __webpack_public_path__ + "img/mobile.5147dad1.jpg";